import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PR_MIGRATION_OFFICER_ROLE } from './auth-roles';
import { KeycloakAuthService } from './keycloak-auth.service';
import { StorageService } from './storage.service';

export const prMigrationOfficerGuard: CanActivateFn = (_route, state) => {
  const keycloakAuth = inject(KeycloakAuthService);
  const router = inject(Router);
  const storageService = inject(StorageService);

  if (!keycloakAuth.isLoggedIn()) {
    storageService.saveRedirectUrl(state.url);
    return router.createUrlTree(['/account/login']);
  }

  if (keycloakAuth.hasRole(PR_MIGRATION_OFFICER_ROLE)) {
    return true;
  }

  return router.createUrlTree(['/applications']);
};
